import { render, staticRenderFns } from "./CTable.vue?vue&type=template&id=655129db&scoped=true"
import script from "./CTable.vue?vue&type=script&lang=js"
export * from "./CTable.vue?vue&type=script&lang=js"
import style0 from "./CTable.vue?vue&type=style&index=0&id=655129db&scoped=true&lang=css"
import style1 from "./CTable.vue?vue&type=style&index=1&id=655129db&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655129db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('655129db')) {
      api.createRecord('655129db', component.options)
    } else {
      api.reload('655129db', component.options)
    }
    module.hot.accept("./CTable.vue?vue&type=template&id=655129db&scoped=true", function () {
      api.rerender('655129db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CTable.vue"
export default component.exports